import AuthenticatedPaths from '../../routing/AuthenticatedRoutes/AuthenticatedRoutes.paths';
import UnauthenticatedPaths from '../../routing/UnauthenticatedRoutes/UnauthenticatedRoutes.paths';

const RETURN_URL_KEY = 'osano_return_url';

const BLOCKED_PATHS = [
    UnauthenticatedPaths.FORGOT_PASSWORD,
    UnauthenticatedPaths.OAUTH,
    UnauthenticatedPaths.RECOVER_PASSWORD,
    UnauthenticatedPaths.RESET_PASSWORD,
    UnauthenticatedPaths.SELECT_MFA,
    UnauthenticatedPaths.SIGN_IN_CONFIRM,
    UnauthenticatedPaths.SIGN_IN,
    UnauthenticatedPaths.SIGN_UP_CONFIRM,
    UnauthenticatedPaths.SIGN_UP_RESEND,
    UnauthenticatedPaths.SIGN_UP,
    AuthenticatedPaths.LOGOUT,
    AuthenticatedPaths.NOT_FOUND,
];

const isValidReturnUrl = url => {
    if (typeof url !== 'string' || !url.startsWith('/') || url.startsWith('//')) return false;
    try {
        const parsed = new URL(url, window.location.origin);
        return parsed.origin === window.location.origin;
    } catch {
        return false;
    }
};

export const saveReturnUrl = url => {
    try {
        if (
            isValidReturnUrl(url) &&
            url !== '/' &&
            !BLOCKED_PATHS.some(blocked => url.startsWith(blocked))
        ) {
            sessionStorage.setItem(RETURN_URL_KEY, url);
        }
    } catch {
        // sessionStorage may be unavailable (private browsing, storage full, etc.)
    }
};

/**
 * Non-destructive read. Safe to call multiple times across re-renders
 * since multiple Redux dispatches during login can trigger several renders
 * before the browser completes the window.location navigation.
 */
export const getReturnUrl = () => {
    try {
        const url = sessionStorage.getItem(RETURN_URL_KEY);
        return isValidReturnUrl(url) ? url : null;
    } catch {
        return null;
    }
};

/**
 * Clear the stored return URL.
 */
export const clearReturnUrl = () => {
    try {
        sessionStorage.removeItem(RETURN_URL_KEY);
    } catch {
        // sessionStorage may be unavailable
    }
};
